<template>
    <!--    <div class="poll-container" :class="{active: userVoted}">-->
    <div class="poll-container"
         :class="containerClass">
        <div class="poll-name">{{item.name}}</div>
        <div class="poll-body">
            <div class="poll-answer" v-for="(answer, index) in item.answers"
                 :class="answer.id == userVote ? 'selected' : ''">
                <div class="name" @click="addVote(index)">{{answer.name}}</div>
                <div class="line" v-if="cantSetVote">
                    <hr :width="getPercent(answer.vote)"/>
                    <div class="row justify-content-between align-items-center">
                        <span class="percent col-auto">{{getPercent(answer.vote)}}</span>
                        <span class="vote col-auto">{{answer.vote}} {{getText(answer.vote)}}</span>
                    </div>

                </div>
            </div>
            <div class="total-votes text-right" v-if="cantSetVote">Всего: {{totalVotes}}
                {{getText(totalVotes)}}
            </div>
        </div>
    </div>
</template>


<script>
    const plural = require('plural-ru');
    export default {
        name: 'poll-form',
        props: {
            item: {
                reqired: true
            },
            typePoll: {
                default: 'active',
            }
        },
        data() {
            return {
                userVoted: false,
                userVote: 0,
            }
        },
        computed: {
            totalVotes() {
                return this.item.answers.reduce((total_vote, a) => total_vote + a.vote, 0)
            },
            cantSetVote() {
                if (this.typePoll == 'disactive') {
                    return true
                }
                if (this.userVoted) {
                    return true
                }
                return false;
            },
            containerClass() {
                if (this.typePoll == 'disactive') {
                    return 'active poll-disactive'
                }
                if (this.userVoted) {
                    return 'active';
                }
                return;
            }

        },
        methods: {
            getText(n) {
                return plural(n, 'голос', 'голоса', 'голосов');
            },
            addVote(index) {
                if (this.userVoted) {
                    return
                }
                if (this.cantSetVote) {
                    return
                }

                let array = this.item.answers;
                this.userVoted = true;
                this.userVote = array[index].id;
                array[index].vote++;

                axios.post('answer/' + array[index].id + '/vote').then(res => {

                }).catch(err => {
                    console.log(err);
                });
                let storegeObj = {
                    userVote: array[index].id,
                    userVoted: true,
                };
                localStorage.setItem('poll_' + this.item.id, JSON.stringify(storegeObj));
            },
            getPercent(vote) {
                let percent = 0;
                if (this.totalVotes != 0) {
                    percent = Math.round((vote * 100) / this.totalVotes);
                }
                return percent + '%';
            },
            getStorageDate() {
                let storageDate = localStorage.getItem('poll_' + this.item.id);
                if (storageDate) {
                    storageDate = JSON.parse(storageDate);
                    this.userVoted = storageDate.userVoted
                    this.userVote = storageDate.userVote
                }
            }
        },
        mounted() {
            this.getStorageDate();

        }
    }
</script>